import { Dialog, useMediaQuery } from '@mui/material';
import { DialogProps } from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import DialogHeader from '@/components/dialogs/dialog-header';

export interface AndonCallDialogHeader {
  maxWidth?: DialogProps['maxWidth'];
  onClose?: (..._: unknown[]) => void;
  onExited?: (..._: unknown[]) => void;
}

const AndonCallDialogHeader: FunctionComponent<AndonCallDialogHeader> = ({
  onClose,
  onExited,
  maxWidth = 'sm',
  children,
}) => {
  const theme = useTheme();
  const [t] = useTranslation();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      fullScreen={fullScreen}
      open
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth}
      scroll="body"
      TransitionProps={{
        onExited,
      }}
    >
      <DialogHeader title={t(['andon:call:title'], { defaultValue: 'Andon Call' })} onClose={onClose} />
      {children}
    </Dialog>
  );
};

export default AndonCallDialogHeader;
